import styled from "styled-components/macro";

import Card from "./Card";

const SmallCard = styled(Card)`
  padding: 0px ${({ theme }) => theme.space[2]}px;
`;

export default SmallCard;
